import { z } from 'zod';
import {
  numberRangeSchema,
  paginationFiltersSchema,
  sortFiltersSchema,
} from 'utils/schemas';
import { benefitCategories } from 'store/benefits';
import { shopItemCategories } from 'types/MarketplaceItems';
import { taxExemptionStatuses } from 'store/shop';
import { recognitionRewardsVariants } from './recognition-rewards.types';

export const recognitionRewardsFiltersSchema = z
  .object({
    name: z.string().catch(''),
    items: z.array(z.string()).catch([]),
    countries: z.array(z.string()).catch([]),
    cities: z.array(z.string()).catch([]),
    suppliers: z
      .object({
        value: z.array(z.string()).catch([]),
        isInverted: z
          .string()
          .transform((v) => (v.toLowerCase() === 'true' ? true : false))
          .catch(false),
      })
      .catch({ value: [], isInverted: false }),
    price: numberRangeSchema,
    benefitCategories: z.array(z.enum(benefitCategories)).catch([]),
    categories: z.array(z.enum(shopItemCategories)).catch([]),
    taxExemptionStatus: z.array(z.enum(taxExemptionStatuses)).catch([]),
    taxExemptionCountries: z.array(z.string()).catch([]),
    invertedFilters: z.array(z.string()).catch([]),
    variant: z.enum(recognitionRewardsVariants).catch('all'),
  })
  .merge(paginationFiltersSchema)
  .merge(sortFiltersSchema);
